/**
 * Standard guidance when a user lacks Backstage / platform access.
 */

import { Link, Typography } from '@material-ui/core';

export function AccessRequestHelp(): JSX.Element {
  return (
    <Typography
      variant="body2"
      color="textSecondary"
      component="p"
      style={{ maxWidth: 520, marginTop: 8, marginBottom: 0 }}
    >
      If you need access, contact{' '}
      <Link href="mailto:devsecops.groups@ironmountain.com">
        devsecops.groups@ironmountain.com
      </Link>{' '}
      for an access request, or raise a <strong>DSO</strong> request with the{' '}
      <strong>Iron Phoenix</strong> type.
    </Typography>
  );
}
